import { render, staticRenderFns } from "./UserNotificationsDialog.vue?vue&type=template&id=33ea7350&scoped=true&"
import script from "./UserNotificationsDialog.vue?vue&type=script&lang=js&"
export * from "./UserNotificationsDialog.vue?vue&type=script&lang=js&"
import style0 from "./UserNotificationsDialog.vue?vue&type=style&index=0&id=33ea7350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ea7350",
  null
  
)

export default component.exports